import React from 'react';
import PropTypes from 'prop-types';

import Icon from './Icon';

const IconEeckmanLogo = ({ style }) => (
    <Icon
        src="/assets/ico-logo-eeckman.svg"
        alt="Logo"
        style={style}
    />
);

IconEeckmanLogo.propTypes = {
    style: PropTypes.shape(),
};
IconEeckmanLogo.defaultProps = {
    style: {},
};

export default IconEeckmanLogo;



// WEBPACK FOOTER //
// ./src/arteia-js/components/Icons/IconEeckmanLogo.js